import React from "react";

import Grid from "../../page-components/SalesAndAnalytics/Grid";

const Dashboard = () => <Grid />;

export default Dashboard;
